import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { connect } from 'react-redux';

import { Modal, Spacer } from '@ontruck/orc';
import { Loading } from 'components/Loading';
import { StyledLoadingContainer } from './styled';

import { UnassignAction, ReleaseAction, CancelAction } from './actions';

import {
  getDecisionModalMode,
  getDecisionModalID,
  getDecisionModalLoading,
  getJobDetailData,
} from 'redux/modules/job-detail/selectors';

import {
  closeDecisionModal,
  unassignJourney,
  removeAndAssign,
  removeAndLaunch,
  removeAndRelease,
} from 'redux/modules/job-detail/effects';

const t = {
  titles: {
    UNASSIGN: 'Unassign driver',
    REMOVE_ORDER: '',
  },
};

class ActionDecisionModal extends Component {
  render() {
    const { closeDecisionModal, unassignJourney, removeAndRelease, loading, mode, item, id } =
      this.props;

    if (!item) {
      return null;
    }

    const content = {
      UNASSIGN: () => (
        <>
          <Spacer mBottom="XS">
            <UnassignAction action={unassignJourney} data-testid="unassign_and_launch" />
          </Spacer>
        </>
      ),
      REMOVE_ORDER: () => (
        <>
          <Spacer mBottom="XS">
            <ReleaseAction
              showOrder={false}
              action={() => removeAndRelease({ id })}
              data-testid="remove_and_release"
            />
          </Spacer>
        </>
      ),
    };

    return (
      <Modal
        show={!!mode}
        size={'S'}
        headerComponent={t.titles[mode]}
        onClose={closeDecisionModal}
        allowClose={!loading}
      >
        {loading && (
          <StyledLoadingContainer>
            <Loading />
          </StyledLoadingContainer>
        )}
        {content[mode] ? content[mode]() : null}
        <CancelAction action={closeDecisionModal} />
      </Modal>
    );
  }
}

ActionDecisionModal.propTypes = {
  closeDecisionModal: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(['UNASSIGN', 'REMOVE_ORDER']),
  unassignJourney: PropTypes.func,
  removeAndAssign: PropTypes.func.isRequired,
  removeAndLaunch: PropTypes.func.isRequired,
  removeAndRelease: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  item: PropTypes.object.isRequired,
  id: PropTypes.number.isRequired,
};

ActionDecisionModal.defaultProps = {};

const actionCreators = {
  closeDecisionModal,
  unassignJourney,
  removeAndAssign,
  removeAndLaunch,
  removeAndRelease,
};

export { ActionDecisionModal };

export default connect(
  (state) => ({
    item: getJobDetailData(state),
    mode: getDecisionModalMode(state),
    id: getDecisionModalID(state),
    loading: getDecisionModalLoading(state),
  }),
  actionCreators
)(ActionDecisionModal);
